import React from 'react';

import styled from '@emotion/styled';

import { BREAKPOINTS, primaryColor, unit, white } from '@zego/theme';

import H1 from '@zego/components/atoms/H1';
import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import ContentContainer from '@zego/components/ContentContainer';

import HomepageHeroBackground from './HomepageHeroBackground.js';

const Container = styled('section')({
  position: 'relative',
  marginTop: -100,
  paddingTop: 100,
  '&::before': {
    position: 'absolute',
    content: '""',
    zIndex: -1,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: primaryColor(13),
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
});

const MainHeader = styled(H1)({
  textAlign: 'center',
  color: white,
});

const Subtitle = styled(RegularText)({
  textAlign: 'center',
  color: white,
  fontSize: 22,
  lineHeight: '24px',
});

const Hero = ({ title, subtitle, children }) => (
  <View css={{ position: 'relative' }}>
    <View css={{ position: 'absolute', top: 0, right: 0, left: 0, bottom: 0 }}>
      <HomepageHeroBackground />
    </View>
    <Container>
      <ContentContainer>
        <div
          css={{
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: 0,
            paddingBottom: unit(6),
            display: 'flex',
            flexDirection: 'column',
            margin: '0 auto',
            [BREAKPOINTS.normal]: {
              paddingTop: unit(6),
            },
          }}
        >
          <MainHeader>{title}</MainHeader>
          <Spacer height={unit(3)} />
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
          <Spacer height={unit(6)} />
          {children}
        </div>
      </ContentContainer>
    </Container>
  </View>
);

export default Hero;
